import { render, staticRenderFns } from "./SelectFieldStock.vue?vue&type=template&id=bd773db0"
import script from "./SelectFieldStock.vue?vue&type=script&lang=js"
export * from "./SelectFieldStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports